import { render, staticRenderFns } from "./FoodTags.vue?vue&type=template&id=2bb8da28&scoped=true&"
import script from "./FoodTags.vue?vue&type=script&lang=js&"
export * from "./FoodTags.vue?vue&type=script&lang=js&"
import style0 from "./FoodTags.vue?vue&type=style&index=0&id=2bb8da28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb8da28",
  null
  
)

export default component.exports